/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlGetAllLibraries = "/library/all";
const urlCreateLibrary = "/library/create";
const urlUpdateLibrary = "/library/update";
const urlDeleteLibrary = "/library/delete";
const urlGetLibraryDetail = "/library/show";

const state = {
  libraries: [],
};

const actions = {
  /**
   * getAllLibraries
   * @param commit
   * @returns {Promise<void>}
   */
  async getAllLibraries({ commit }) {
    try {
      const response = await axios.get(urlGetAllLibraries);
      if (response.data.status_code === 200) {
        commit("SET_ALL_LIBRARIES", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  /**
   * getLibraryDetail
   * @param commit
   * @param params
   * @returns {Promise<*>}
   */
  async getLibraryDetail({ commit }, params) {
    return await axios.get(
      urlGetLibraryDetail + "?" + new URLSearchParams(params),
    );
  },

  /**
   * createLibrary
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async createLibrary({ commit }, payload) {
    try {
      const response = await axios.post(urlCreateLibrary, payload);
      return response.data.status_code === 200;
    } catch (e) {
      return false;
    }
  },

  /**
   * updateLibrary
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async updateLibrary({ commit }, payload) {
    try {
      const response = await axios.post(urlUpdateLibrary, payload);
      return response.data.status_code === 200;
    } catch (e) {
      return false;
    }
  },

  /**
   * deleteLibrary
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async deleteLibrary({ commit }, payload) {
    try {
      const response = await axios.post(urlDeleteLibrary, payload);
      return response.data.status_code === 200;
    } catch (e) {
      return false;
    }
  },
};

const mutations = {
  SET_ALL_LIBRARIES(state, data) {
    state.libraries = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
